import { render, staticRenderFns } from "./MakeupTraitPreview.vue?vue&type=template&id=0a9ba5bb&scoped=true&"
import script from "./MakeupTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./MakeupTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MakeupTraitPreview.vue?vue&type=style&index=0&id=0a9ba5bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9ba5bb",
  null
  
)

export default component.exports